import { Component, OnInit } from '@angular/core';
import { Details }    from './details';
import * as $ from 'jquery';
import * as CryptoJS from 'crypto-js';
import { sha256, sha224 } from 'js-sha256';
import { ToastrService } from 'ngx-toastr';
import { RecaptchaComponent } from 'ng-recaptcha';

import {LoginService} from '../login.service';
import {FormBuilder, ReactiveFormsModule, FormsModule, NgControl, FormGroup } from '@angular/forms';
import { Router,RouterModule} from '@angular/router';
import { DatePipe } from '@angular/common';
import { ServerConstantsService } from '../serverConstants.service';




@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public details = new Details('','','','','','','','','','','','',null,{question:'Choose One Question',answer:''},{question:'Choose One Question',answer:''},{question:'Choose One Question',answer:''},false,'');
  public username:any;
  public password:any;
  public checked: Boolean = false;
  public error:Boolean = true;
  visible:Boolean = false;
  errorMessage:any;
  count:any =0;
  questions:any=[];
  questions1:any=[];
  questions2:any=[];
  questions3:any=[];
  loader:Boolean = false;
  invalidLogin:Boolean = true;
  invalidLogin2:any='Y';
  loginMessage:any;
  forgotEmail:any;
  forgotMessage:any="Email/Username address does not exist";
  forgotsw:Boolean = true;
  forgotAnswer:any;
  securedQuestions:any =[];
  secureCount:any = 0;
  success:Boolean = false;
  errorMessage2:any;
  passworderror:Boolean = true;
  security4:Boolean = false;
  security5:Boolean = false;
  recaptcha:Boolean = false;
  digit1:Number;
  digit2:Number;
  digit3:Number;
  digit4:Number;
  digit5:Number;
  digit6:Number;
  mfa:Boolean = false;
  verificationError:Boolean = true;
  val:any;
  termsEnglish:any = 1;
  agree:any;
  tmSw:Boolean = false;
  usernameError:Boolean = false;
  forgotemailError:Boolean = false;
  multiEmail:any;
  clientId:any;
  Usernameemail:any='';
  checkerror:Boolean = false;

  constructor(public loginService:LoginService, private router:Router, public toastService:ToastrService, public datePipe: DatePipe) { }

  ngOnInit() {
    this.load();
  }
  load(){
    let imgCount = 1;

    this.loginService.getSecurityQuestions().subscribe((data)=>{
      this.questions = data;
      this.questions1 = this.questions.slice();
      this.questions2 = this.questions.slice();
      this.questions3 = this.questions.slice();
    },error=>{
      this.toastService.error("Unable to load security questions.",'Create an account');
    });

  }

  public onSubmit(event: Event){
    event.preventDefault();
    let request = {
      email:this.username,
      password:btoa(this.password),
      username:this.username
    }
    this.loader = true;
    this.loginService.authenticate(request).subscribe((data)=>{
      this.loader = false;
      if(data["@result"].toLowerCase().trim() == "success"){
        this.clientId = data["@clientInfo"];
        if(data['@mfa'] == 'Y'){
          this.tmSw = true;
        }
        this.getUserInfo(this.clientId,'Y');
        /*if(ServerConstantsService.serverConstants.loginMfa == true){
          this.mfa = true;
          this.getUserInfo
          this.multifactor(this.username);
        }
        else{
          this.getUserInfo(this.clientId);
        }*/
        this.invalidLogin = true;
        this.invalidLogin2 = 'Y';
      }
      else{
        this.invalidLogin2 = data["@trailCount"];
        this.invalidLogin = false;
        this.loginMessage = data["@result"];
        setTimeout(()=>{
          $("span.state").html('Log in');
          $("form").removeClass('ok loading');
          $("#password").focus();
          $("form").addClass('swing');
        },0);
      }
    },error=>{
      this.loader = false;
      this.invalidLogin = false;
      /*$("#errorMessage").click();
      this.errorMessage = JSON.stringify(error.error);*/
      this.toastService.error("Error occured.",'Log In');
      this.loader = false;
      setTimeout(()=>{
        $("span.state").html('Log in');
        $("form").removeClass('ok loading');
        $("#password").focus();
        $("form").addClass('swing');
      },0);
    })
  }
  public exchange(){
    document.querySelector('.cont').classList.toggle('s--signup');
  }
  next(){
    this.count +=1;
  }
  previous(){
    this.count = this.count -1;
  }
  checkUsername(){
    let request = {
      username:this.details.username
    }
    this.loginService.checkUsername(request).subscribe((data)=>{
      if(data["result"] == "success"){
        this.checkerror = false;
      }
      else{
        this.checkerror = true;
        this.details.username = '';
      }
    },error=>{
      this.toastService.error("Unable to check username availability.",'Create an account');
    })
  }
  validate(){
    this.error = false;
    if(this.details.dob != undefined && this.details.dob != null && this.details.dob != ''){
      let pastDate = new Date(this.details.dob.substring(0, 2)+'-'+this.details.dob.substring(2, 4)+'-'+this.details.dob.substring(4, 8));
      let currentDate = new Date();
      currentDate.setFullYear(currentDate.getFullYear()-16);
      if(!(parseInt(this.details.dob.substring(0, 2)) <= 12 && parseInt(this.details.dob.substring(2, 4)) <=31 )){
        this.details.dob = null;
      }
      else if(pastDate>currentDate || pastDate > new Date()){
        this.details.dob = null;
      }
    }
    if(this.details.confirmPassword != undefined && this.details.confirmPassword != null){
      if(this.details.confirmPassword != this.details.password){
        this.details.confirmPassword = null;
      }
    }
  }
  activate(){
    this.error = true;
  }
  nextFocus(value,event){
    if(event.key === "Backspace"){
      setTimeout(()=>{
        event.target.previousElementSibling.focus();
      },0)
    }
    else{
      setTimeout(()=>{
        document.getElementById(value).focus();
      },0)
    } 
  }
  toggle(){
    this.visible = !this.visible; 
  }
  updateQuestions(){
    this.questions1 = this.questions.filter(question => question.description.trim() !== this.details.security2.question && question.description.trim() !== this.details.security3.question);
    this.questions2 = this.questions.filter(question => question.description.trim() !== this.details.security1.question && question.description.trim() !== this.details.security3.question);
    this.questions3 = this.questions.filter(question => question.description.trim() !== this.details.security1.question && question.description.trim() !== this.details.security2.question);
  }
  signUp(event){
    if (ServerConstantsService.serverConstants.registrationMfa == true) {
      this.multifactor(this.details.email);
      this.mfa = true;
    }
    else {
      this.registration();
    }
  }
  registration(){
      const dob = this.details.dob;
      this.details.dob = this.details.dob.substring(4, 8) + '-' + this.details.dob.substring(0, 2) + '-' + this.details.dob.substring(2, 4);
      this.loader = true;
      let key = sha256(ServerConstantsService.serverConstants.privateKey);
      let encrypted = CryptoJS.AES.encrypt(JSON.stringify(this.details), key.toString());
      let request = {
        details: encrypted.toString()
      }
      this.loginService.signUp(request).subscribe((data) => {
      this.loader = false;
      if(data["id"]){
        this.clientId = data["id"];
        this.getUserInfo(this.clientId,'N');
        sessionStorage.setItem('id',CryptoJS.AES.encrypt(this.clientId.toString(),key).toString());
      }
      else if(data["errorCode"]){
        $("#errorMessage").click();
        /*this.errorMessage = "You have already an account. Please Login with your credentials.";*/
        this.toastService.error("You already have an account,Please log in with your credentials.", 'Create an account');
        this.details.dob = dob;
        this.mfa = false;
      }
      else{
        this.toastService.error("This Website is for Arkansas citizens who are participating in the Employment & Training program.If you are an Employment & Training participant,please talk yo your provider about your access to the system. If you are not currently enrolled, please click the Help button for more information",'Create an account',
          { 'disableTimeOut': true, 'closeButton': true });
        this.details.dob = dob;
      }
    },error=>{
      this.toastService.error("Unable to create an account.", 'Create an account');
      this.details.dob = dob;
      this.loader = false;
    });
  }
  securityValidate1(){
    if(this.details.security1.question.trim() == "Choose One Question"){
      this.details.security1.answer = "";
    }
  }
  securityValidate2(){
    if(this.details.security2.question.trim() == "Choose One Question"){
      this.details.security2.answer = "";
    }
  }
  securityValidate3(){
    if(this.details.security3.question.trim() == "Choose One Question"){
      this.details.security3.answer = "";
    }
  }
  forgotPassword(){
    if(this.forgotMessage != "Incorrect Answer"){
      let request = {
        email:this.forgotEmail,
        username:this.forgotEmail
      }
      this.loginService.forgotPassword(request).subscribe((data)=>{
        if(data["security"]){
          this.forgotsw = true;
          this.forgotMessage = "Incorrect Answer";
          data["security"].forEach((element)=>{
            this.securedQuestions.push(JSON.parse(CryptoJS.AES.decrypt(element, "security").toString(CryptoJS.enc.Utf8)));
          })
          this.Usernameemail = data["email"];
        }
        else if(data["result"]=="locked"){
          this.forgotsw = false;
          this.forgotMessage = "Your account has been locked.Please contact Administrator.";
          this.Usernameemail = '';
        }
        else{
          this.forgotsw = false;
          this.forgotMessage = "Email/Username address does not exist";
          this.Usernameemail = '';
        }
      },error=>{
        this.toastService.error("Unable to load security questions",'Forgot password');
        this.Usernameemail = '';
      })
    }
    /*else if(this.secureCount >= 2){
      this.forgotAnswer = "";
      this.forgotsw = false;
      this.forgotMessage = "Your account has been locked.Please contact Administrator.";
    }*/
    else{
      this.forgotsw = false;
      if(this.secureCount == 2 && (this.securedQuestions[this.secureCount].answer != this.forgotAnswer)){
        this.forgotAnswer = "";
        this.forgotsw = false;
        this.forgotMessage = "Your account has been locked.Please contact Administrator.";
        this.Usernameemail = '';
        this.lockUser();
      }
      else if(this.securedQuestions[this.secureCount].answer == this.forgotAnswer){
        this.success = true;
        this.forgotAnswer = "";
        this.forgotsw = true;
        this.forgotMessage = "Your account has been locked.Please contact Administrator.";
        this.temporaryPassword(this.Usernameemail);
      }
      else{
        this.forgotAnswer = "";
        this.secureCount = this.secureCount + 1;
      }
    }
    
  }
  resolved(event){
    this.recaptcha = true;
  }
  manageQuestion(){
    sessionStorage.setItem('count','1');
  }
  validation(){
    if(!(/[a-z]/g.test(this.details.password))){
      this.passworderror = false;
      this.errorMessage2 = "Password must contain one lowercase letter.";
    }
    else if(!(/[A-Z]/g.test(this.details.password))){
      this.passworderror = false;
      this.errorMessage2 = "Password must contain one uppercase letter.";
    }
    else if(!(/[0-9]/g.test(this.details.password))){
      this.passworderror = false;
      this.errorMessage2 = "Password must contain one numeric.";
    }
    else if(!(/[!@#$%\^&*)(+=._-]/g.test(this.details.password))){
      this.passworderror = false;
      this.errorMessage2 = "Password must contain one special character.";
    }
    else if(this.details.password.length <8){
      this.passworderror = false;
      this.errorMessage2 = "Minimum length for password is 8.";
    }
    else{
      this.passworderror = true;
      this.errorMessage2 = "";
    }
  }
  multifactor(email){
    this.multiEmail = email;
    this.loader = true;
    this.val = Math.floor(100000 + Math.random() * 900000).toString();
    let request;
        request = {
          address:email,
          code:CryptoJS.AES.encrypt(this.val,'code').toString()
        }
    //alert(this.val);
    this.loginService.sendVerification(request).subscribe((data)=>{
      this.loader = false;
      if (data["message"] == "Sent Successfully") {
        if((this.details.ssn !== '') && (this.details.ssn !== null) && (this.details.ssn !== undefined)){
          $("#register").click();
          $("#signIn").click();
        }
        
        this.mfa = true;
      }
      else{
        this.toastService.error("Unable to send verification code to email.",'Login Verification');
      }
    },error=>{
      this.loader = false;
      this.toastService.error("Unable to send verification code to email.",'Login Verification');
    })
  }
  authenticate(event) {
    event.preventDefault();
    if (this.val == this.digit1.toString() + this.digit2.toString() + this.digit3.toString() + this.digit4.toString() + this.digit5.toString() + this.digit6.toString()) {
      if((this.details.ssn !== '') && (this.details.ssn !== null) && (this.details.ssn !== undefined)){
          this.registration();
      }
      else{
        this.getUserInfo(this.clientId,'N');
      }
    }
    else{
      this.verificationError = false;
    }
  }
  temporaryPassword(email){
    let request = {
      address:email
    }
    this.loginService.sendEmail(request).subscribe((data)=>{
      if(!data["message"]){
        this.toastService.error("Unable to send temporary password to email.",'Forgot password');
      }
    },error=>{
      this.toastService.error("Unable to send temporary password to email.",'Forgot password');
    })
  }
  lockUser(){
    let request={
      address:this.forgotEmail,
      username:this.forgotEmail
    }
    this.loginService.lockUser(request).subscribe((data)=>{
      if(data["result"]!="success"){
        this.toastService.error("Error occured.",'Forgot password');
      }
    },error=>{
      this.toastService.error("Error occured.",'Forgot password');
    })
  }
  getUserInfo(id,sw){
    console.log('START ============== login.component.ts::getUserInfo ID : ' + id + ' sw flag :' + sw);
    this.loginService.getuser(id).subscribe((data)=>{
      if(data["id"]){
        console.log('login.component load');
        this.loginService.load();
        this.loginService.personId = data["id"];
        console.log(' this.loginService.personId ' + this.loginService.personId);
        console.log('ServerConstantsService.serverConstants.privateKey ' + ServerConstantsService.serverConstants.privateKey);
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        console.log(' key ' + key);
        sessionStorage.setItem('id',CryptoJS.AES.encrypt(data["id"].toString(),key).toString());
        this.loginService.firstName = data["firstName"];
        console.log('this.loginService.firstName ' + this.loginService.firstName);
        sessionStorage.setItem("firstName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        this.loginService.lastName = data["lastName"];
        console.log('this.loginService.lastName ' + this.loginService.lastName);
        sessionStorage.setItem("lastName",CryptoJS.AES.encrypt(data["firstName"].toString(),key).toString());
        if((sw == 'Y' && ServerConstantsService.serverConstants.loginMfa == true)){
          console.log('Using mfa authentication');
          this.multifactor(data["email"]);
          this.mfa = true;
        }
        else{
          console.log('calling getcitizenInfo');
          this.getcitizenInfo(data["ssn"]);
        }
      }
      else{
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
    console.log('END ============== login.component.ts::getUserInfo');
  }
  getcitizenInfo(ssn){
    console.log('START ============== login.component.ts::getcitizenInfo');
    $(".loader").removeClass('hide');
    let request = {
      "ssn":ssn
    }
    this.loader = true;
    this.loginService.getClientinfo(request).subscribe((data:Array<Object>)=>{
      setTimeout(()=>{
        $(".loader").addClass('hide');
    },1000)
      this.loader = false;
      console.log('data : ' + data);
      if(data != undefined && data[0] !=undefined && data[0]["CLIENTID"]){
        let key = sha256(ServerConstantsService.serverConstants.privateKey).toString();
        if(data[0]["BENEFIT"] == null || data[0]["BENEFIT"] == ''){
          this.loginService.monthlyBenefit = 0;
        }
        else{
          this.loginService.monthlyBenefit = data[0]["BENEFIT"];
          sessionStorage.setItem('benefit',CryptoJS.AES.encrypt(data[0]["BENEFIT"].toString(),key).toString());
        }
        if((data[0]["HH_MEM_RELATIONSHIP"] !== undefined) && (data[0]["HH_MEM_RELATIONSHIP"] !== null) && (data[0]["HH_MEM_RELATIONSHIP"] !== '')){     
            this.loginService.participationCode = data.find(obj => obj['HH_MEM_RELATIONSHIP'] == 'Self')['HH_MEM_WP'];
            sessionStorage.setItem('status',CryptoJS.AES.encrypt(this.loginService.participationCode.toString(),key).toString());
        }
        //this.loginService.maxWage=Math.max.apply(Math, this.loginService.staticData.get("Maxwages").map(function(o) { return o.value; }));
        if(data[0]["CONVERSION_STAT"] === 'CM'){
          this.router.navigate(['redirect/transfer']);
        }
        else{
          if(this.tmSw == true){
            this.router.navigate(['changepassword']);
          }
          else{
            this.router.navigate(['dashboard']);
          }
        }
      }
      else{
        this.toastService.error("Unable to load User Information","My Dashboard");
      }
    },error=>{
      setTimeout(()=>{
        $(".loader").addClass('hide');
    },1000)
      this.toastService.error("Unable to load User Information","My Dashboard");
    })
    console.log('END ============== login.component.ts::getcitizenInfo');
  }

}
RecaptchaComponent.prototype.ngOnDestroy = function() {
  if (this.subscription) {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts